module.exports = __webpack_public_path__ + "09_face.f627fb81.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer1/09_face.png
// module id = cCGN
// module chunks = 0